<template lang="pug">
  b-form(@submit.stop.prevent="onSubmit")
    .ml-2.text-danger {{ errorDetail }}
    b-form-group(invalid-feedback="Este campo es requerido")
      .input-title Ids de Envíos
      b-form-input#id-list.input.w-100(
        v-model="form.idList"
        placeholder="Ej: 1234, 2353, 533..."
        :state="$v.$dirty ? !$v.form.idList.$invalid : null"
      )
    hr.linea
    b-form-group(invalid-feedback="Este campo es requerido")
      .input-title Fecha
      b-form-input#date-input.input(
        v-model="form.date"
        type="date"
        :state="$v.$dirty ? !$v.form.date.$invalid : null"
      )
    hr.linea
    .text-right
      b-button(type="submit" :disabled="loading") Guardar
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import MakeToastMixin from '../mixins/MakeToastMixin'

export default {
  mixins: [MakeToastMixin],
  props: {
    ids: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      errorDetail: null,
      form: {
        idList: '',
        date: null
      }
    }
  },
  validations: {
    form: {
      idList: { required },
      date: { required }
    }
  },
  methods: {
    ...mapActions(['listUser', 'bulkUpdateDeliveryDate']),
    async onSubmit () {
      this.loading = true
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        const response = await this.bulkUpdateDeliveryDate({ data: this.data })
        if (response.status >= 200 && response.status < 300) {
          this.makeSuccessToast(response.data.message || 'Las fechas se actualizaron correctamente')
          this.$emit('done')
        } else if (response.status >= 400) {
          this.makeDangerToast(response.data.message || 'Error al cambiar fechas')
          console.log(response)
          this.errorDetail = response.data.detail
        }
      }
      this.loading = false
    }
  },
  computed: {
    ...mapGetters(['drivers']),
    data () {
      let deliveriesIds = this.form.idList.replace(' ', '', 'g').split(',')
      deliveriesIds = deliveriesIds.map(id => id.trim())
      return {
        date: this.form.date,
        deliveriesIds
      }
    }
  },
  created () {
    this.form.idList = this.ids.join(', ')
    this.listUser()
  }
}
</script>
